import ImageCarousel from './ImageCarousel';
import { SiteContent } from '../content';

type OutdoorContent = SiteContent['outdoor'];

interface OutdoorSectionProps {
  content: OutdoorContent;
  getImageUrl: (name: string) => string;
}

export default function OutdoorSection({ content, getImageUrl }: OutdoorSectionProps) {
  return (
    <section id="outdoor" className="section-dark">
      {/* Text Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-center">
        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-semibold mb-6">
          {content.title}
        </h2>
        <p className="text-lg md:text-xl text-milan-gray-light leading-relaxed max-w-2xl mx-auto mb-10">
          {content.description}
        </p>

        {/* Amenities Grid */}
        {content.amenities.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-3xl mx-auto">
            {content.amenities.map((amenity, index) => (
              <div
                key={index}
                className="flex items-center justify-center sm:justify-start text-left px-4 py-3"
              >
                <svg
                  className="w-5 h-5 text-white mr-3 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-white/90">{amenity}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Full-width Carousel */}
      <ImageCarousel
        images={content.images}
        getImageUrl={getImageUrl}
        autoplay={true}
        autoplayDelay={6500}
      />
    </section>
  );
}
